import { PagedResult } from "./types";
import CompanyLogDTO, { CompanyLogType } from "@/dto/CompanyLogDTO";
import httpClient from "../http/mainServerClient";

interface GetCompanyLogListParams {
    pageNo: number;
    pageSize: number;
    logType: CompanyLogType;
}

export async function getCompanyLogList(params: GetCompanyLogListParams) {
    return httpClient.post<PagedResult<CompanyLogDTO>>("/company_log/list", params);
}
